export default "__VITE_ASSET__cDh6Jdyw__"